import {createFileRoute} from '@tanstack/react-router';
import {DepositAccountTransferCallbackErrorPage} from 'features/deposit/transfer/DepositAccountTransferCallbackErrorPage';

export const Route = createFileRoute('/_protected/transfer/callback/failed')({
  component: DepositAccountTransferCallbackErrorPage,
});
